import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'lcl-external-quote-notification',
  templateUrl: './lcl-external-quote-notification.component.html',
  styleUrls: ['./lcl-external-quote-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclExternalQuoteNotificationComponent {
  @Output() public close: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}
}
